import gql from 'graphql-tag';

/* ---------------------------------------------------------------- */
/* Defaults από entity_params (φιλτραρισμένα στο entityType του user) */
/* ---------------------------------------------------------------- */
export const gqlGetEntityParams = gql`
  query getEntityParams($limit: Int, $offset: Int, $order: String, $where: String) {
    getEntityParams(limit: $limit, offset: $offset, order: $order, where: $where) {
      data {
        id
        paramName
        entityType
        intValue
        applies
      }
      recordCount
    }
  }
`;

export const gqlGetAppparams = gql`
  query getAppparams($limit: Int, $offset: Int, $order: String, $where: String) {
    getAppparams(limit: $limit, offset: $offset, order: $order, where: $where) {
      data {
        id
        paramName
        paramGroup
        description
        notes
      }
      recordCount
    }
  }
`;

/* ---------------------------------------------------------------- */
/* Overrides από usr_params_values (ανά userName)                    */
/* ---------------------------------------------------------------- */
export const gqlGetUserUsrParamsValues = gql`
  query getUserUsrParamsValues($userName: String) {
    getUserUsrParamsValues(userName: $userName) {
      data {
        id
        userName
        paramName
        intValue
        lastDate
        lastUser
      }
      recordCount
    }
  }
`;

export const gqlAddUsrParamsValue = gql`
  mutation addUsrParamsValue($data: UsrParamsValueInput) {
    addUsrParamsValue(data: $data) {
      id
      userName
      paramName
      intValue
    }
  }
`;

export const gqlUpdateUsrParamsValue = gql`
  mutation updateUsrParamsValue($data: UsrParamsValueInput) {
    updateUsrParamsValue(data: $data) {
      id
      userName
      paramName
      intValue
    }
  }
`;

export const gqlDeleteUsrParamsValue = gql`
  mutation deleteUsrParamsValue($id: Int) {
    deleteUsrParamsValue(id: $id)
  }
`;
